module.exports = __webpack_public_path__ + "img/gruppenalt.11e39606.jpg";